import React from 'react';

export function AppShellSkeleton() {
  return (
    <div className="flex h-screen w-screen bg-canvas overflow-hidden">
      <div className="w-64 shrink-0 bg-sidebar border-r border-sidebar-line flex flex-col">
        <div className="flex h-16 shrink-0 items-center border-b border-sidebar-line px-4 gap-3">
          <div className="h-9 w-9 rounded-xl bg-surface-2 animate-pulse shrink-0" />
          <div className="flex flex-col gap-1.5 flex-1">
            <div className="h-3 w-10 rounded bg-surface-2 animate-pulse" />
            <div className="h-2 w-20 rounded bg-surface-2 animate-pulse" />
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 flex flex-col gap-0.5">
          <div className="px-3 pb-2">
            <div className="h-2 w-16 rounded bg-surface-2 animate-pulse" />
          </div>
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-10 rounded-xl bg-surface-2 animate-pulse" />
          ))}
          <div className="px-3 pb-2 pt-6">
            <div className="h-2 w-20 rounded bg-surface-2 animate-pulse" />
          </div>
          {[...Array(3)].map((_, i) => (
            <div key={i + 6} className="h-10 rounded-xl bg-surface-2 animate-pulse" />
          ))}
        </nav>
        <div className="border-t border-sidebar-line p-3">
          <div className="h-9 rounded-xl bg-surface-2 animate-pulse" />
        </div>
      </div>
      <div className="flex-1 flex flex-col min-w-0">
        <header className="flex h-16 shrink-0 items-center justify-between gap-3 border-b border-line bg-surface px-4">
          <div className="flex items-center gap-3">
            <div className="h-5 w-5 rounded bg-surface-2 animate-pulse" />
            <div className="h-4 w-40 rounded bg-surface-2 animate-pulse" />
          </div>
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-full bg-surface-2 animate-pulse" />
            <div className="h-8 w-8 rounded-full bg-surface-2 animate-pulse" />
            <div className="h-8 w-8 rounded-full bg-surface-2 animate-pulse" />
            <div className="h-7 w-px bg-surface-2 animate-pulse" />
            <div className="h-8 w-32 rounded-lg bg-surface-2 animate-pulse" />
          </div>
        </header>
        <main className="flex-1 overflow-auto p-6 flex flex-col gap-5">
          <div className="flex flex-col gap-2">
            <div className="h-7 w-56 rounded bg-surface-2 animate-pulse" />
            <div className="h-4 w-80 rounded bg-surface-2 animate-pulse" />
          </div>
          <div className="grid grid-cols-3 gap-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-28 rounded-xl bg-surface-2 animate-pulse" />
            ))}
          </div>
          <div className="h-48 rounded-xl bg-surface-2 animate-pulse" />
          <div className="h-32 rounded-xl bg-surface-2 animate-pulse" />
        </main>
      </div>
    </div>
  );
}
